import Icon, { IconNames } from "components/Icon/Icon";

const fileIcons: { [key: string]: IconNames } = {
  ".html": "BsFiletypeHtml",
  ".jpg": "BsFiletypeJpg",
  ".jpeg": "BsFiletypeJpg",
  ".png": "BsFiletypePng",
  ".gif": "BsFiletypeGif",
  ".svg": "BsFiletypeSvg",
};

interface IFileIcon {
  ext?: string;
  className?: string;
}

function FileIcon({ ext, className = "w-8 h-8 shrink-0" }: IFileIcon) {
  const lowerExt = ext?.toLowerCase() ?? "";

  if (lowerExt === ".pdf") {
    return (
      <img
        src="/images/pdf-logo.png"
        alt="PDF"
        className={`object-contain ${className}`}
      />
    );
  }
  if (lowerExt === ".doc" || lowerExt === ".docx") {
    return (
      <img
        src="/images/word-logo.png"
        alt="Word"
        className={`object-contain ${className}`}
      />
    );
  }
  if (lowerExt === ".xls" || lowerExt === ".xlsx" || lowerExt === ".csv") {
    return (
      <img
        src="/images/excel-log.png"
        alt="Excel"
        className={`object-contain ${className}`}
      />
    );
  }

  const iconName: IconNames = fileIcons[lowerExt] ?? "BsFileEarmark";
  return <Icon name={iconName} className={className} />;
}

export default FileIcon;
